//Create main itxApp module
(function () {
    'use strict';

    window.itxApp = window.itxApp || {};

    //For compatibility with old functions and MSpots
    window.Inditex = window.inditex;

})();

//Add language locale to html tag
(function () {
    'use strict';
    inditex.onReady(function () {
        //TODO rtl
        if(inditex.iLocale){
            $('html').attr('lang', inditex.iLocale.replace("_", "-"));
        }

        if (window && !window.ng) {
            if( inditex.iPage === 'ItxOrderConfirmationPage' ||
                inditex.iPage === 'ItxCheckoutAuthPage' ||
                inditex.iPage === 'ItxCheckoutPage' ||
                inditex.iPage === 'ItxWorldWidePage' )
            {
                addTagManager();
                checkRTL();
            }
        }

        var pagesNotBlockedAssitedPurchase = ['ItxCheckoutPage', 'ItxOrderConfirmationPage'];
        if (
            inditex.phonePurchase === 1 &&
            pagesNotBlockedAssitedPurchase.indexOf(inditex.iPage) === -1
        ) {
            $('body').append(
                [
                    '<div class="loader">',
                    '<div class="sk-circle">',
                    'BLOCKED',
                    '</div>',
                    '</div>'
                ].join('')
            );
        }
    });

    function checkRTL() {
        //Add class is-rtl to arabic languages (arabic languageId = -44)
        if (inditex.iLangId === -44 || inditex.iLangId === -52) {
            $('body').addClass('is-rtl');
            $('body').attr('dir', 'rtl');
        } else {
            $('body').addClass('is-ltr');
            $('body').attr('dir', 'ltr');
        }
    }

    function addTagManager() {
        inditex.onReady(function () {
            var $injector = $('body').injector();
            $injector.invoke([
                'DUTTI_CONS',
                'CommonServices',
                function (DUTTI_CONS, CommonServices) {
                    
                    var timer = setInterval(function() {
                        if (window.OneTrust !== undefined) {
                            clearInterval(timer);
                            callIfOnTrustItsLoaded()
                        }
                    }, 50);

                    // llamar en la funcion
                    function callIfOnTrustItsLoaded () {
                        const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(DUTTI_CONS.COOKIE_GROUPS.ANALYTICS);
                        if (isCookieGroupAllowed) {
                            window.dataLayer = window.dataLayer || [];
                            window.imAnalytics = window.imAnalytics || {};
                            var id,
                                nossource = '',
                                source = '',
                                noscript,
                                script;
                            id = inditex.getSessionStorage('IMGTM');
    
                            if (id) {
                                nossource += '<iframe src="//www.googletagmanager.com/ns.html?id=';
                                nossource +=
                                    id + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                                source += "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':";
                                source += "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],";
                                source += "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=";
                                source +=
                                    "'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);";
                                source += "})(window,document,'script','dataLayer','" + id + "');";
                                noscript = $('<noscript>');
                                script = $('<script>');
                                noscript.html(nossource);
                                script.html(source);
                                $('head').prepend(script);
                                $('head').prepend(noscript);
                            } else {
                                joyr.rest.xRestGetXConfiguration('TAG_MANAGER_CODE_RESPONSIVE').done(function (value) {
                                    id = value || 'GTM-NRD3FV';
                                    inditex.setSessionStorage('IMGTM', value);
                                    nossource += '<iframe src="//www.googletagmanager.com/ns.html?id=';
                                    nossource +=
                                        id + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                                    source += "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':";
                                    source +=
                                        "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],";
                                    source += "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=";
                                    source +=
                                        "'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);";
                                    source += "})(window,document,'script','dataLayer','" + id + "');";
                                    noscript = $('<noscript>');
                                    script = $('<script>');
                                    noscript.html(nossource);
                                    script.html(source);
                                    $('head').prepend(script);
                                    $('head').prepend(noscript);
                                });
                            }
    
                            window.tagManagerInitialized = true;
                        }
                    }
                    
                }
            ]);
        });
    }
})();

//Prevent cache in firefox & Safari browsers
// (function () {
//     'use strict';

//     window.onpageshow = function (event) {
//         if (event.persisted) {
//             window.location.reload();
//         }
//     };
// })();


//Store latest visited page
(function () {
    'use strict';

    $(window).on('pagehide', function () {
        inditex.setSessionStorage('latest-visited-page', inditex.iPage);
    });
})();

//If no country selected in the Country ISO, redirect to worldwide.
(function () {
    'use strict';
    /*
    function isHome(){
        return inditex.iPage == 'ItxWorldWidePage' || inditex.iPage == 'ItxHomePage';
    }*/
    inditex.onReady(function () {
        try {
            // if(inditex.iCountryCode === 'WW' && inditex.getLocalStorage('COUNTRY_ISO') == null && inditex.iPage != 'ItxWorldWidePage'){
            let isoWebCountries = [];
            inditex.getXconfiguracionValue('WEB_WW_COUNTRY_ISOS', function(status, value) {
                if (value) {
                    isoWebCountries = value.split(',');
                }
            });

            if (isoWebCountries.includes(inditex.iCountryCode)) {
                if (
                    inditex.getLocalStorage('COUNTRY_ISO') == null &&
                    inditex.iPage != 'ItxWorldWidePage'
                ) {
                    var url = inditex.getWorldWideUrl(false);
                    if (url.indexOf('.cn/') > -1) {
                        url = url.replace('.cn/', '.com/');
                    }
                    window.location.href = url;
                }

                // WORLD WIDE save redirect params
                var _categoryId, _productId;
                if (inditex.iUrlJSON.params) {
                    _categoryId = inditex.iUrlJSON.params.categoryId;
                    _productId = inditex.iUrlJSON.params.productId;
                }

                var expressionProductURl = /.*c(\d{6,8})p?(\d{6,8})?.*/;
                if (
                    (!_productId || !_categoryId) &&
                    expressionProductURl.test(document.location.href)
                ) {
                    var expArray = expressionProductURl.exec(document.location.href);
                    _categoryId = expArray[1];

                    if (expArray.length >= 3) {
                        _productId = expArray[2];
                    }
                }
                if (_categoryId) {
                    inditex.setLocalStorage(
                        'REDIRECT_CATEGORY',
                        JSON.stringify({
                            categoryId: _categoryId,
                            productId: _productId
                        })
                    );
                } else {
                    inditex.removeLocalStorage('REDIRECT_CATEGORY');
                }
            } else if (inditex.iPage !== 'ItxWorldWidePage' && inditex.iCountryCode !== 'WW') {
                inditex.removeLocalStorage('COUNTRY_ISO');
            }
        } catch (error) {
            inditex.removeLocalStorage('REDIRECT_CATEGORY');
        }

        inditex.setLocalStorage('LAST_STORE_JSON', JSON.stringify(inditex.iStoreJSON));
    });
})();

(function () {
    'use strict';

    $(document).ready(function () {
        document.addEventListener('keyup', function () {
            document.documentElement.classList.add('has-focus');
        });

        document.addEventListener('mousedown', function () {
            document.documentElement.classList.remove('has-focus');
        });
    });
})();

//Add classes for devices
(function () {
    //jshint ignore:line
    'use strict';

    if (navigator.userAgent.match(/iPad/i)) {
        $('html').addClass('ipad');
    }

    if (navigator.userAgent.match(/iPhone/i)) {
        $('html').addClass('iphone');
    }

    if (navigator.userAgent.match(/Android/i)) {
        $('html').addClass('android');
    }

    var rv;
    if (navigator.appName === 'Microsoft Internet Explorer') {
        var ua = navigator.userAgent,
            re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');

        if (re.exec(ua) !== null) {
            rv = parseFloat(RegExp.$1);
        }
    } else if (navigator.appName === 'Netscape') {
        /// in IE 11 the navigator.appVersion says 'trident'
        /// in Edge the navigator.appVersion does not say trident
        if (navigator.appVersion.indexOf('Trident') === -1) {
            rv = 12;
        } else {
            rv = 11;
        }
    }

    if (rv < 12) {
        $('html').addClass('explorer');
    }
})();

/**
 * Fixes
 */
(function () {
    'use strict';
    inditex.onReady(function () {
        $(document).ready(function () {
            $(document.body).addClass('category_' + inditex.iCategoryId);

            if (
                ($('.notification.notification-action').length ||
                    $('.notification.notification-info').length) &&
                inditex.phonePurchase !== 1
            ) {
                $('body').addClass('notification-mspot');
            }
            /*
            var time = moment(inditex.getLocalStorage('time_traveler'), 'YYYY-MM-DD-HH:mm:ss'); //jshint ignore:line

            if (document.location.search.indexOf('time_traveler') > -1 || time.isValid()) {
                $('#page').append('<itx-time-traveler-help></itx-time-traveller-help>');
            }
            */
        });
        if (String(navigator.userAgent).toLowerCase().indexOf('massimodutti_ecom') > -1) {
            $('body').addClass('webapp');
        }
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/FBAV/i)) {
            $('body').addClass('facebook_webview');
        }
        if (
            navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
            navigator.userAgent.match(/Instagram/i)
        ) {
            $('body').addClass('instagram_webview');
        }

        //GLOBAL FUNCTIONS
        function findCategory(categoryId, categories) {
            // jshint ignore:line

            var category = null;
            for (var i = 0; i < categories.length; i++) {
                if (categories[i].id === categoryId) {
                    return categories[i];
                } else {
                    category = findCategory(categoryId, categories[i].subcategories);
                    if (category) {
                        return category;
                    }
                }
            }
            return null;
        }

        function getCategoryUrl(categoryId, isMobile, isAjax) {
            // jshint ignore:line

            if (!categoryId) {
                throw new ReferenceError('Missing parameter: categoryId');
            }
            return inditex.encodeUrl({
                action: 'ItxCategoryPage',
                params: {
                    storeId: inditex.iStoreId,
                    langId: inditex.iLangId,
                    catalogId: inditex.iCatalogId,
                    categoryId: categoryId
                },
                isMobile: isMobile ? isMobile : false,
                isAjax: isAjax ? isAjax : false
            });
        }
    });
})();

// Rakuten - Configure your page to set the following JavaScript variable (window._rmcp2) whenever consent is collected
(function () {
    'use strict';
    inditex.onReady(function () {
        var $injector = $('body').injector();
        if ($injector) {
            $injector.invoke([
                'DUTTI_CONS',
                'CommonServices',
                function (DUTTI_CONS, CommonServices) {
                    const cookieGroupAnalysis = DUTTI_CONS.COOKIE_GROUPS.ANALYTICS;
                    const cookieGroupBehaviouralAdvertising = DUTTI_CONS.COOKIE_GROUPS.BEHAVIOURAL_ADVERTISING;

                    const isCookieGroupAnalysisAllowed = CommonServices.isCookieGroupAllowed(cookieGroupAnalysis);
                    const isCookieGroupBehaviouralAdvertisingAllowed = CommonServices.isCookieGroupAllowed(cookieGroupBehaviouralAdvertising);
                    if (isCookieGroupBehaviouralAdvertisingAllowed && isCookieGroupAnalysisAllowed) {
                        window.__rmcp2 = [1, 2, 3, 4, 7, 8, 9, 10];
                    } else if (isCookieGroupBehaviouralAdvertisingAllowed) {
                        window.__rmcp2 = [1, 2, 3, 4, 7, 9, 10];
                    } else if (isCookieGroupAnalysisAllowed) {
                        window.__rmcp2 = [1, 7, 8, 10];
                    } else {
                        inditex.cookieConsent.addConsentChangedHandler(function (activeGroups) {
                            if (activeGroups) {
                                if (
                                    activeGroups['C0002'] &&
                                    activeGroups['C0002'].allowed &&
                                    activeGroups['C0004'] &&
                                    activeGroups['C0004'].allowed
                                ) {
                                    window.__rmcp2 = [1, 2, 3, 4, 7, 8, 9, 10];
                                } else if (
                                    activeGroups['C0004'] &&
                                    activeGroups['C0004'].allowed
                                ) {
                                    window.__rmcp2 = [1, 2, 3, 4, 7, 9, 10];
                                } else if (
                                    activeGroups['C0002'] &&
                                    activeGroups['C0002'].allowed
                                ) {
                                    window.__rmcp2 = [1, 7, 8, 10];
                                }
                            }
                        });
                    }
                }
            ]);
        }
    });
})();